import { Grid, IconButton, useTheme } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { ROUTE } from '@/constants/routes';

import { useAppSelector } from '@/hooks/redux';
import { useNavigateBack } from '@/hooks/useNavigateBack';

import { selectConfigsState } from '@/redux/configs';

import { HeaderMobileProps } from '@/types/components/layout';

import { Icon } from '../Icon/Icon';

import { Container, Slot } from './HeaderMobile.styled';

export function HeaderMobile({
  leftSlot,
  centerSlot,
  rightSlot,
  isOnDark,
  bgColor,
  onBack: customOnBack,
  layoutWidths = [2, 8, 2],
  position = 'fixed',
}: HeaderMobileProps) {
  const onBack = useNavigateBack(ROUTE.HOME);
  const theme = useTheme();
  const { headerLogoIconOnDark, headerLogoIconOnLight, headerLogoIconSx } =
    useAppSelector(selectConfigsState);

  const centerLogoName = isOnDark
    ? (headerLogoIconOnDark ?? 'logo')
    : (headerLogoIconOnLight ?? 'logo');

  return (
    <Container
      isOnDark={isOnDark}
      bgColor={bgColor?.(theme)}
      position={position}
    >
      <Grid container>
        {layoutWidths[0] && (
          <Grid item xs={layoutWidths[0]}>
            <Slot>
              {leftSlot !== undefined ? (
                leftSlot
              ) : (
                <IconButton onClick={customOnBack || onBack}>
                  <Icon
                    name="arrow-left-alt"
                    color={(theme: Theme) =>
                      isOnDark
                        ? theme.palette.common.white
                        : theme.palette.neutral[700]
                    }
                  />
                </IconButton>
              )}
            </Slot>
          </Grid>
        )}
        {layoutWidths[1] && (
          <Grid item xs={layoutWidths[1]}>
            <Slot justifyContent="center">
              {centerSlot !== undefined ? (
                centerSlot
              ) : (
                <Icon
                  name={centerLogoName}
                  size={44}
                  {...(headerLogoIconSx ? { sx: headerLogoIconSx } : {})}
                  color={(theme: Theme) =>
                    isOnDark
                      ? theme.palette.common.white
                      : theme.palette.primaries[400]
                  }
                />
              )}
            </Slot>
          </Grid>
        )}

        {layoutWidths[2] && (
          <Grid item xs={layoutWidths[2]}>
            <Slot justifyContent="flex-end">{rightSlot}</Slot>
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
